import type { DeliveryType, OrderInfo } from '@@partner:types:app'
import type { GQL_ID } from '@@partner:types:graphql'

import { gql, useMutation } from '@apollo/client'

import {
  ORDER_FIELDS,
  ORDER_PRODUCTS_FIELDS,
  ORDER_SHOP_FIELDS,
  ORDER_TOTALS_FIELDS
} from '@@partner:graphql/shortcuts'

export type EditOrderInfoMutationVariableData = Partial<Pick<OrderInfo,
  'address'
  | 'address_appartments'
  | 'address_floor'
  | 'address_intercom'
  | 'address_porch'
  | 'customerGeoPoint'
  | 'slot_id'
  | 'zone_id'
  | 'shop_id'
> & {
  delivery_type: DeliveryType
}>

export interface UpdateOrderInfoMutation {
  updated: OrderInfo
}
export interface UpdateOrderInfoMutationVariables {
  order_id: GQL_ID
  newData: EditOrderInfoMutationVariableData // TODO: make better type
}


export const GQL_MUTATION_EDIT_ORDER_INFO = gql`
  mutation editOrderInfo ($order_id: ID!, $newData: OrderInfoInput!) {
    updated: editOrderInfo(order_id: $order_id, newData: $newData) {
      ${ORDER_FIELDS}
      ${ORDER_SHOP_FIELDS}
      ${ORDER_PRODUCTS_FIELDS}
      ${ORDER_TOTALS_FIELDS}
    }
  }
`


export const useEditOrderInfo = () =>
  useMutation<UpdateOrderInfoMutation, UpdateOrderInfoMutationVariables>(
    GQL_MUTATION_EDIT_ORDER_INFO
  )
